// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    GatewayError,
    MangoCardDetailsRequest,
    MangoHubGetPatientAccountSummary,
    MangoHubGetPatientWelcomeSummaryResponse,
    MangoHubGivePatientConsentResponse,
    MangoHubRevokePatientConsentResponse,
    MangoHubVerifyPatientRequest,
    MangoHubVerifyPatientResponse,
    MangoV1CardDetailsGetCardDetailsResponse,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeMangoApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param mangoCardDetailsRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async cardDetailsGetCardDetails (mangoCardDetailsRequest: MangoCardDetailsRequest, xProgramId?: string): Promise<AxiosResponse<MangoV1CardDetailsGetCardDetailsResponse>> {
        const _url_ = '/edge/mango/v1/cardDetails/getCardDetails';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'mangoCardDetailsRequest' is not null or undefined
        if (mangoCardDetailsRequest === null || mangoCardDetailsRequest === undefined) {
            throw new Error('Required parameter mangoCardDetailsRequest was null or undefined when calling cardDetailsGetCardDetails.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(mangoCardDetailsRequest, "MangoCardDetailsRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<MangoV1CardDetailsGetCardDetailsResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MangoV1CardDetailsGetCardDetailsResponse");
        }
        return response;
    }
    /**
     * 
     * @param activationCode 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async hubGetPatientAccountSummary (activationCode: string, xProgramId?: string): Promise<AxiosResponse<MangoHubGetPatientAccountSummary>> {
        const _url_ = '/edge/mango/v1/hub/getPatientAccountSummary/{activationCode}'
            .replace('{' + 'activationCode' + '}', encodeURIComponent(String(activationCode)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'activationCode' is not null or undefined
        if (activationCode === null || activationCode === undefined) {
            throw new Error('Required parameter activationCode was null or undefined when calling hubGetPatientAccountSummary.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<MangoHubGetPatientAccountSummary>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MangoHubGetPatientAccountSummary");
        }
        return response;
    }
    /**
     * 
     * @param activationCode 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async hubGetPatientWelcomeSummary (activationCode: string, xProgramId?: string): Promise<AxiosResponse<MangoHubGetPatientWelcomeSummaryResponse>> {
        const _url_ = '/edge/mango/v1/hub/getPatientWelcomeSummary/{activationCode}'
            .replace('{' + 'activationCode' + '}', encodeURIComponent(String(activationCode)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'activationCode' is not null or undefined
        if (activationCode === null || activationCode === undefined) {
            throw new Error('Required parameter activationCode was null or undefined when calling hubGetPatientWelcomeSummary.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<MangoHubGetPatientWelcomeSummaryResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MangoHubGetPatientWelcomeSummaryResponse");
        }
        return response;
    }
    /**
     * 
     * @param activationCode 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async hubGivePatientConsent (activationCode: string, xProgramId?: string): Promise<AxiosResponse<MangoHubGivePatientConsentResponse>> {
        const _url_ = '/edge/mango/v1/hub/givePatientConsent/{activationCode}'
            .replace('{' + 'activationCode' + '}', encodeURIComponent(String(activationCode)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'activationCode' is not null or undefined
        if (activationCode === null || activationCode === undefined) {
            throw new Error('Required parameter activationCode was null or undefined when calling hubGivePatientConsent.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<MangoHubGivePatientConsentResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MangoHubGivePatientConsentResponse");
        }
        return response;
    }
    /**
     * 
     * @param activationCode 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async hubRevokePatientConsent (activationCode: string, xProgramId?: string): Promise<AxiosResponse<MangoHubRevokePatientConsentResponse>> {
        const _url_ = '/edge/mango/v1/hub/revokePatientConsent/{activationCode}'
            .replace('{' + 'activationCode' + '}', encodeURIComponent(String(activationCode)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'activationCode' is not null or undefined
        if (activationCode === null || activationCode === undefined) {
            throw new Error('Required parameter activationCode was null or undefined when calling hubRevokePatientConsent.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<MangoHubRevokePatientConsentResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MangoHubRevokePatientConsentResponse");
        }
        return response;
    }
    /**
     * 
     * @param mangoHubVerifyPatientRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async hubVerifyPatient (mangoHubVerifyPatientRequest: MangoHubVerifyPatientRequest, xProgramId?: string): Promise<AxiosResponse<MangoHubVerifyPatientResponse>> {
        const _url_ = '/edge/mango/v1/hub/verifyPatient';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'mangoHubVerifyPatientRequest' is not null or undefined
        if (mangoHubVerifyPatientRequest === null || mangoHubVerifyPatientRequest === undefined) {
            throw new Error('Required parameter mangoHubVerifyPatientRequest was null or undefined when calling hubVerifyPatient.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(mangoHubVerifyPatientRequest, "MangoHubVerifyPatientRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<MangoHubVerifyPatientResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "MangoHubVerifyPatientResponse");
        }
        return response;
    }
}
